import { env } from "@/config/env";
import { ANALYTICS_PROVIDER } from "../models";
import type { QuoraEvent } from "../models";
import { handleAnalyticsError } from "../utils";

export const initQuoraTracking = ({ email }: { email: string }) => {
  try {
    const quoraPixelId = env.VITE_QUORA_PIXEL_ID;

    if (!window.qp || !quoraPixelId) {
      throw new Error("Quora not initialized");
    }

    window.qp("init", env.VITE_QUORA_PIXEL_ID, { email });
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error initializing Quora",
      provider: ANALYTICS_PROVIDER.QUORA,
      extra: {
        email,
      },
    });
  }
};

interface QuoraTrackingParams {
  event: QuoraEvent;
  options?: Record<string, string | number>;
}

export const triggerQuoraTracking = ({
  event,
  options,
}: QuoraTrackingParams) => {
  try {
    if (!window.qp) {
      throw new Error("Quora not initialized");
    }

    window.qp("track", event, options);
  } catch (error) {
    handleAnalyticsError(error, {
      message: "Error tracking Quora event",
      provider: ANALYTICS_PROVIDER.QUORA,
      extra: {
        event,
        options,
      },
    });
  }
};
